"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_LINE_KEYS = void 0;
// The source of truth for these keys is the `svc_line` table in the Operations database, so these keys
// must be updated if they change in the database.
exports.SERVICE_LINE_KEYS = {
    ROLL_OFF: 'ROLL_OFF',
    UNIVERSAL_SERVICE: 'UNIVERSAL_SERVICE',
    COMMERCIAL: 'COMMERCIAL',
    PT_LOO: 'PT_LOO',
};
//# sourceMappingURL=service-line-keys.js.map